import Utils from '@/common/utils/utils';
import { CircularProgress } from '@material-ui/core';
import { useEffect } from 'react';
import { useState } from 'react';

function LiveChatMessageFromMe({ message, sentMessageList, isModePreview }) {
    const [messageState, seMessageState] = useState(message);
    const [isLoadingPostMessage, setIsLoadingPostMessage] = useState(!isModePreview);

    useEffect(() => {
        if (message.updatedAt !== messageState.updatedAt || message.id !== messageState.id) {
            seMessageState(message);
        }
    }, [message]);

    const getUUIDOfId = id => {
        return id.slice(Math.max(id.length - 36, 0));
    };

    useEffect(() => {
        const uuid = getUUIDOfId(message.id);
        const idMessageObject = sentMessageList.find(item => {
            return item.hasOwnProperty(uuid);
        });
        if (Utils.isEmptyObject(idMessageObject)) return;
        if (idMessageObject[uuid]?.includes('post')) {
            setIsLoadingPostMessage(false);
        }
    }, [sentMessageList]);

    return (
        <>
            {isLoadingPostMessage ? (
                <main
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#0099FF',
                        color: '#f1f1f1',
                        borderRadius: '16px 0 16px 16px',
                        paddingLeft: '4px'
                    }}
                >
                    <CircularProgress size={14} color={'inherit'} style={{ marginRight: '5px' }} />
                    <div
                        className="message-text loading-post-message"
                        dangerouslySetInnerHTML={{
                            __html: Utils.replaceUrls(
                                Utils.escapeHtmlCharacters(message.content),
                                false,
                                false,
                                'color-white loading-post-message'
                            )
                        }}
                    ></div>
                </main>
            ) : (
                <div
                    className="message-text"
                    dangerouslySetInnerHTML={{
                        __html: Utils.replaceUrls(
                            Utils.escapeHtmlCharacters(message.content),
                            false,
                            false,
                            'color-white'
                        )
                    }}
                ></div>
            )}
        </>
    );
}

export default LiveChatMessageFromMe;
